import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import FieldGroup from '../FieldGroup';
import SectionTitle from '../SectionTitle';
import Card from '../Card';
import { FiArrowRight, FiInfo } from 'react-icons/fi';

function Step5BusinessSEO() {
  const { projectDraft, dispatch } = useAppContext();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: value } });
  };
  
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload: { [name]: checked } });
  };

  return (
    <div className="space-y-6">
      <SectionTitle title="Business & SEO" subtitle="Provide your business details and SEO preferences." />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FieldGroup label="Company Name">
          <input 
            type="text" 
            name="companyName" 
            value={projectDraft.companyName || ''} 
            onChange={handleChange} 
            className="form-input" 
            placeholder="Your Company Name"
          />
        </FieldGroup>
        
        <FieldGroup label="Business Email">
          <input 
            type="email" 
            name="businessEmail" 
            value={projectDraft.businessEmail || ''} 
            onChange={handleChange} 
            className="form-input" 
            placeholder="contact@company.com"
          />
        </FieldGroup>
      </div>
      
      <FieldGroup label="SEO Keywords" description="Comma-separated keywords for search optimization">
        <textarea 
          name="seoKeywords" 
          value={projectDraft.seoKeywords || ''} 
          onChange={handleChange} 
          rows={3} 
          className="form-input" 
          placeholder="web development, react, modern design"
        />
      </FieldGroup>
      
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <div className="flex items-start">
          <FiInfo className="h-5 w-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
          <div>
            <input 
              type="checkbox" 
              name="hideFromSearch" 
              id="hideFromSearch" 
              checked={projectDraft.hideFromSearch || false} 
              onChange={handleCheckboxChange} 
              className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" 
            />
            <label htmlFor="hideFromSearch" className="ml-2 text-sm">
              <span className="font-medium text-gray-900">Hide from Search Engines</span>
              <p className="text-gray-600 mt-1">Prevent search engines from indexing this site during development</p>
            </label>
          </div>
        </div>
      </div>

      <Card className="bg-gradient-to-r from-indigo-50 to-purple-50 border-indigo-200">
        <div className="flex items-start">
          <div className="flex-1">
            <h3 className="font-bold text-lg text-gray-800">Ready for Setup?</h3>
            <p className="text-sm text-gray-600 mt-2">
              Once you generate your prompt, use our Setup Guides to configure GitHub, databases, hosting, and other services step-by-step.
            </p>
          </div>
          <button
            onClick={() => navigate('/setup-guides')}
            className="ml-4 btn-secondary flex-shrink-0"
          >
            Setup Guides 
            <FiArrowRight className="ml-2 h-4 w-4" />
          </button>
        </div>
      </Card>
    </div>
  );
}

export default Step5BusinessSEO;